function ModernPopupHeader({
  onClose,
  children,
  segmentPaddingButton = false,
}) {
  return (
    <div
      className="mph-container"
      style={segmentPaddingButton ? { paddingBottom: "0px" } : {}}
    >
      <div className="close-modern-popup" onClick={onClose}>
        <img
          src={`${process.env.PUBLIC_URL}/images/icons/close_popup.svg`}
          alt="Close"
        />
      </div>
      {/* This is the "Slot" where your custom icon/title/button will go */}
      <div className="header-content-modern-popup">{children}</div>
    </div>
  );
}

export default ModernPopupHeader;
